import { PaymentsIcon } from '@finnairoyj/fcom-ui-styles/enums';

export enum PaymentCards {
  AX = 'amex',
  VI = 'visa',
  DC = 'dinersclub',
  CA = 'mastercard',
  TP = 'uatp',
  JC = 'jcb',
}

export interface PaymentCardData {
  token: string;
  expiry: string;
  vendor: string;
  cardType: string;
  corporate?: boolean;
  cardHolder: string;
  billingAddress: string;
  postCode: string;
  city: string;
  country: string;
  name: string;
  logo: {
    alt: string;
    href: string;
  };
  expiryDate?: string;
  lastDigits?: string;
  svgName?: PaymentsIcon;
}

export interface PaymentCardsResponse {
  tokens: PaymentCardData[];
}
